import React from "react";
import routes from "./routes";

const AppWrapper = () => {
  return <div>{routes()}</div>;
};

export default AppWrapper;
